export enum FecThirdPartyStatus {
  Existing = 'existing',
  New = 'new',
}
